module.exports = __webpack_public_path__ + "static/media/logo_1.b99e23fe.svg";